import { render, staticRenderFns } from "./AccountParams.vue?vue&type=template&id=c6808232&scoped=true"
import script from "./AccountParams.vue?vue&type=script&lang=js"
export * from "./AccountParams.vue?vue&type=script&lang=js"
import style0 from "./AccountParams.vue?vue&type=style&index=0&id=c6808232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6808232",
  null
  
)

export default component.exports